import React, { useState } from 'react'
import styles from './ImagesEdit.module.css'
import NewSlider from '../../pages/NewSlider/NewSlider'
import noImage from '../../assets/img/no-image.jpg'
import TitleBlockForEditPages from '../TitleBlockForEditPages/TitleBlockForEditPages'
import UploadPhotoComponent from '../UploadPhotoComponent/UploadPhotoComponent'
import exit from '../../assets/icons/trash.svg'
import { UploadImagesType } from '../../types'
import iconEdit from '../../assets/icons/iconEdit.svg'
import CustomButton from '../UI/CustomButton/CustomButton'
import { useAppSelector } from '../../redux/types/types'

interface Props {
  onDeleteImageFromServer: (image: string) => any
  onUploadNewImages: (photosFile: any, setPhotos: any) => any
  error?: unknown
  currentObjectImages: string[]
  imagesFull: {
    id: number
    src: string
  }[]
}

const ImagesEdit: React.FC<Props> = ({
  imagesFull,
  onUploadNewImages,
  currentObjectImages,
  error,
  onDeleteImageFromServer,
}) => {
  const { userRole } = useAppSelector((state) => state.auth)
  const [photos, setPhotos] = useState<UploadImagesType[]>([])
  const [photosFile, setPhotosFile] = useState<any[]>([])
  const [edit, setEdit] = useState(false)

  const handleDeleteImage = (e: any) => {
    const targetIndex = e.target.dataset.imgindex * 1
    setPhotos([...photos.slice(0, targetIndex), ...photos.slice(targetIndex + 1)])
  }
  return (
    <div>
      {!edit ? (
        <div>
          <div className={styles.header}>
            <h2 className={styles.title}>Изображения</h2>
            {(userRole === 'superAdmin' ||
              userRole === 'admin' ||
              userRole === 'employeePlace' ||
              userRole === 'directorPlace' ||
              userRole === 'directorAgent') && (
              <CustomButton
                iconSrc={iconEdit}
                className={styles.btn}
                title={''}
                onClick={() => setEdit(true)}
              />
            )}
          </div>
          {imagesFull.length !== 0 ? (
            <div className={styles.slider}>
              <NewSlider slides={imagesFull} />
            </div>
          ) : (
            <div className={styles.slider}>
              <img className={styles.noImage} src={noImage} alt='noImage' />
            </div>
          )}
        </div>
      ) : (
        <div>
          <TitleBlockForEditPages
            setEdit={setEdit}
            title={'Изображения'}
            disabled={false}
            handleSubmit={() => onUploadNewImages(photosFile, setPhotos)}
          />
          <div className={styles.imageUpload}>
            <UploadPhotoComponent
              editMode
              photos={photos}
              photosFile={photosFile}
              setPhotos={setPhotos}
              widthOneImageContainer={245}
              widthOneGapOfImageContainer={20}
              setPhotosFiles={setPhotosFile}
            >
              <>
                {currentObjectImages.length > 0 &&
                  currentObjectImages.map((image, index) => {
                    return (
                      <div
                        className={styles.imagesContainer}
                        key={index}
                        data-imgindex={index + 100}
                      >
                        <div className={styles.imageExitContainer}>
                          <img
                            className={styles.imageExit}
                            src={exit}
                            alt='exit'
                            onClick={() => onDeleteImageFromServer(image)}
                            data-imgindex={index}
                          />
                        </div>
                        <img
                          className={styles.image}
                          src={`${process.env.REACT_APP_BASE_URL_IMAGES}${image}`}
                          alt={image}
                        />
                      </div>
                    )
                  })}
                {photos.length > 0 &&
                  photos.map((photo, index) => {
                    return (
                      <div className={styles.imagesContainer} key={index} data-imgindex={index}>
                        <div className={styles.imageExitContainer}>
                          <img
                            className={styles.imageExit}
                            src={exit}
                            alt='exit'
                            onClick={handleDeleteImage}
                            data-imgindex={index}
                          />
                        </div>
                        <img className={styles.image} src={photo?.src} alt={photo.name} />
                      </div>
                    )
                  })}
              </>
            </UploadPhotoComponent>
            <>
              {error && (
                <p className={`${styles.errorValidation} ${styles.networkError}`}>
                  {error as string}
                </p>
              )}
            </>
          </div>
        </div>
      )}
    </div>
  )
}

export default ImagesEdit
